const { chain, includes } = require('lodash');

const catalogs = {
  en: { messages: require('./locale/en/messages.json') }, // eslint-disable-line global-require
  zh: { messages: require('./locale/zh/messages.json') }, // eslint-disable-line global-require
};

const defaultLanguage = 'zh';
const alternateLanguage = 'en';

const languages = [defaultLanguage, alternateLanguage];

const langPrefix = lang => (lang === defaultLanguage ? '' : `/${lang}`);
const deprefix = pathname => (pathname.startsWith(`/${alternateLanguage}/`) ? pathname.substr(4) : pathname);
const langFromPath = pathname => (pathname.startsWith(`/${alternateLanguage}/`) ? alternateLanguage : defaultLanguage);

const browserLanguagePropertyKeys = ['languages', 'language', 'browserLanguage', 'userLanguage', 'systemLanguage'];
const getLocale = () => chain(window.navigator)
  .pick(browserLanguagePropertyKeys)
  .values()
  .flatten()
  .compact()
  .map(s => s.substr(0, 2))
  .find(s => includes(languages, s))
  .value() || defaultLanguage;

exports.defaultLanguage = defaultLanguage;
exports.alternateLanguage = alternateLanguage;
exports.languages = languages;
exports.catalogs = catalogs;
exports.langPrefix = langPrefix;
exports.deprefix = deprefix;
exports.langFromPath = langFromPath;
exports.getLocale = getLocale;



// WEBPACK FOOTER //
// ./src/i18n-config.js